import { useQueryClient } from '@tanstack/react-query';

import { VetRxContent } from '../lib';
import { VET_RX_CONTENT_KEY } from './queryKey';

export const useVetRxContentQuery = () => {
    const queryClient = useQueryClient();

    const vetRxData = queryClient.getQueryData<VetRxContent>([VET_RX_CONTENT_KEY]);

    return { ...vetRxData };
};
